// extracted by mini-css-extract-plugin
module.exports = {"root":"ColorSelect__root--3tF42","checkboxLabel":"ColorSelect__checkboxLabel--wWhQ1"};